import React from 'react';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit}) => {
    const rows = [
        { label: 'Material Code', value: data.materialCode },
        { label: 'Material Type', value: data.materialTypeName },
        { label: 'Inventory Type', value: data.inventoryType  === 1 ? 'Feed Mill' : 'Farm' },
        { label: 'Minimum Stock Value', value: data.minimumStockValue },
        { label: 'Opening Stock', value: data.openingStock },
        { label: 'Current Stock', value: data.currentStock },
        { label: 'Opening Value', value: data.openingValue },
        { label: 'Storage Loss', value: data.storageLoss },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={data.materialName}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
